import './SliderOfIconicTiles.scss';
import { $, SlickSlider } from "../../../common/scripts/Libs";

class SliderOfIconicTiles {

  constructor(node) {
    this.node = node;
  }

  init() {
    $(this.node).find('.sliderOfIconicTiles__slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,

      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    }, SlickSlider);
  }

}

JSModules['SliderOfIconicTiles'] = SliderOfIconicTiles;
export default SliderOfIconicTiles;
